import React from 'react';
import styled from '@emotion/styled';

const SVGContainer = styled.div<{
  src: string;
  color: string;
  width: string;
  height: string;
  center: boolean;
}>`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  mask-image: ${({ src }) => 'url(' + src + ')'};
  mask-size: contain;
  mask-repeat: no-repeat;
  mask-position: ${({ center }) => (center ? 'center' : 'initial')};
  background-color: ${({ color }) => color};
`;

export interface Props {
  src: string;
  color?: string;
  width?: string;
  height?: string;
  center?: boolean /* New prop to control centering */;
  style?: React.CSSProperties;
  className?: string;
}

const Icon = ({
  src,
  color = 'white',
  width = '24px',
  height = '24px',
  center = false /* Default is false, meaning no centering by default */,
  style,
  className = '',
}: Props) => {
  return (
    <SVGContainer
      className={`SVG-icon ${className}`}
      src={src}
      color={color}
      width={width}
      height={height}
      center={center}
      style={style}
    />
  );
};

export default React.memo(Icon);
